var _path, _path2, _g, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgFuneralHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3810_20616",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3810_20616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2701 11.9748C57.2701 11.9748 70.1073 13.8995 69.1076 28.6572C68.1085 43.4132 79.445 38.4428 80.1134 48.3871C80.7789 58.3326 83.1656 55.6214 85 62.9997C86.835 70.3791 81.6642 75.9904 78.3297 79.039C74.9963 82.0871 33.4258 94.2612 21.4232 77.2572C9.41651 60.2533 20.588 50.4689 24.0888 47.2609C27.5901 44.0529 31.5902 41.1653 26.9241 36.1937C22.2532 31.2198 29.5926 26.889 30.7585 26.5692C31.9268 26.2482 30.6427 19.6079 36.3092 14.7957C41.981 9.98399 48.8498 8.33663 57.2701 11.9748Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7077 51.1672H57.6473V48.5732H42.1V51.1645C42.1 53.703 42.0894 56.4623 39.8789 58.1314V82.9996H49.8737C49.8737 82.9996 55.1072 82.9996 59.8684 82.9996V58.0926C57.7145 56.4193 57.7077 53.6839 57.7077 51.1672Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8741 74.4127C46.5682 74.4127 42.3948 71.7113 40.373 70.2959L43.2109 103H58.7582V70.2959C56.2389 72.8839 53.18 74.4127 49.8741 74.4127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 64.8361L41 63L50 74.377L48.5 79L34 64.8361Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 64.8361L59 63L50 74.377L51.5 79L66 64.8361Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7575 63.0112C59.1627 63.1218 59.5276 63.1807 59.868 63.2093V58.0937C57.7142 56.4204 57.7073 53.6849 57.7073 51.1681L57.7058 51.1037V48.5098L45.4312 48.5742L42.0996 49.6847C44.3207 52.1836 51.1228 60.929 58.7575 63.0112Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4207 34.1358C65.4207 43.029 56.5761 54.1253 49.8735 54.1253C43.1708 54.1253 34.3262 43.029 34.3262 34.1358C34.3262 25.2426 41.287 21.9199 49.8735 21.9199C58.4599 21.9199 65.4207 25.2426 65.4207 34.1358Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 31.9995C68 34.4995 67 36.4995 66.5 38.4995C66.1 40.0995 64 40.8328 63 40.9995V32.4995C63.6667 31.4995 65.3 29.9995 66.5 31.9995Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7923 32.0164C31.2931 34.5941 32.2926 36.6562 32.7923 38.7183C33.1921 40.368 35.291 41.1242 36.2905 41.296V32.532C35.6242 31.5009 33.9917 29.9543 32.7923 32.0164Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.426 23.0306C57.462 30.3415 61.5339 33.65 65.3514 34.6217C67.4432 35.1542 68.5314 29.5833 68.5314 29.5833C68.5314 29.5833 63.5699 20.9946 63.1998 20.8097C62.8297 20.6245 59.8682 14.1465 59.8682 14.1465L53.2051 19.6992L55.426 23.0306Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 25.9997C43 37.4997 36 38.1664 32 39.4997V29.9997L38.5 20.4997C41.3333 19.6664 48 17.5997 52 15.9997C56 14.3997 57.3333 19.9997 57.5 22.9997C55 21.833 48.8815 20.5904 47 25.9997Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6373 56.8018C39.5176 58.4916 37.2347 59.6795 32.5497 59.6795H32.1512C24.8881 59.6795 19 65.1487 19 71.8954V99.669C19 101.509 20.6058 103.001 22.5867 103.001H47L40.6373 56.8018Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 58.5C38 62 35.3003 69.2 38.5003 76C35.5002 85.5 38.5002 88 46.0002 104.5",
    stroke: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1104 56.8018C60.2301 58.4916 62.513 59.6795 67.198 59.6795H67.5964C74.8595 59.6795 80.7477 65.1487 80.7477 71.8954V99.669C80.7477 101.509 79.1419 103.001 77.161 103.001H53L59.1104 56.8018Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0227 59C62.0232 62.4163 64.7236 69.4441 61.5228 76.0815C64.5236 85.3543 61.5229 87.7946 54.021 103.9",
    stroke: "#292929"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.751 3.60331C86.1252 -0.325702 79.6302 1.64228 79.6302 1.64228L79.5745 1.684C77.2787 2.28272 75.2419 3.61619 73.7749 5.48089L74.7485 27.0383H89.7691L90.3811 5.11233L91.751 3.60331Z",
    fill: "#787B7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1635 27.0662L77.1899 5.50879C77.1899 5.50879 83.4485 -3.14894 93.4693 4.81339C93.5781 4.91075 93.6803 5.01529 93.7752 5.12632L92.4331 27.0662H78.1635Z",
    fill: "#413D45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4514 7.50391H84.8589V16.1477H86.4514V7.50391Z",
    fill: "#C1C1C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5936 10.1475H82.6758V11.7399H88.5936V10.1475Z",
    fill: "#C1C1C1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFuneralHome);
export default __webpack_public_path__ + "static/media/imgFuneralHome.503743180518bc58a89094555bd092fe.svg";
export { ForwardRef as ReactComponent };